"use strict";
'use es6';

require("i18n-data/static-1.62/data/currency");